/** Gerado por scripts/baixar-logos-bancos.mjs — slugs que têm arquivo em public/bancos/<slug>.png. */
export const LOGOS_BANCOS: ReadonlySet<string> = new Set<string>([])
